import { setupTabs } from "@/components/tabs"
import { setupNavbar } from "@/components/navbar"

import AccordionController from "../controllers/accordion_controller"
import CampaignController from "../controllers/campaign_controller"
import GoogleOneTapController from "../controllers/google_one_tap_controller"
import TrustpilotController from "../controllers/trustpilot_controller"

import Emarsys from "@/helpers/emarsys"
import { setupGa4 } from "@/helpers/ga4_helper"
import { register } from "@/helpers/stimulus"

import { setupFooter } from "@/components/footer"

const setTurboEvalFalse = (): void => {
  // Add `data-turbo-eval="false"` to all scripts in `body` after the page has loaded, to prevent
  // them from re-running on back/forward. This has no effect on regular navigations (since `body`
  // is replaced entirely).

  // Skip scripts with `data-turbo-eval="true"` to selectively allow those to re-run.
  const scriptSelector = "script:not([data-turbo-eval='true'])"

  // Only scripts in `body`, not `head`. Turbo merges `head` scripts by comparing each existing
  // one with version from the server (regular navigations) or cached version (back/forward) and
  // skips running those that match. If we add the attribute to a `head` script here it wouldn't
  // matter for back/forward (since both copies would have the attribute), but for regular
  // navigations the script would not match the server's copy and Turbo would run it again.
  document.body.querySelectorAll(scriptSelector).forEach((script) => {
    script.setAttribute("data-turbo-eval", "false")
  })
}

const scriptMutationObserver = (callback: () => void): void => {
  new window.MutationObserver((mutations): void => {
    mutations.forEach((mutation) => {
      if ([...mutation.addedNodes].some((node) => node.nodeName === "SCRIPT")) {
        callback()
      }
    })
    // Observe `document` rather than `document.body` because Turbo replaces `body` on every
    // render, so an observer attached to it is dropped after the first navigation.
  }).observe(document, { subtree: true, childList: true })
}

const setupStimulus = (): void => {
  register("accordion", AccordionController)
  register("campaign", CampaignController)
  register("google-one-tap", GoogleOneTapController)
  register("trustpilot", TrustpilotController)
}

setupStimulus()

setupFooter()
setupTabs()
setupNavbar()

// This gets called on every page to ensure the cart events get sent to emarsys.
Emarsys(window.emarsysData)

setupGa4()
setTurboEvalFalse()
scriptMutationObserver(setTurboEvalFalse)
